module.exports = __webpack_public_path__ + "static/media/san-marino.f3ac998e.png";